import { useEffect } from 'react'

import { useNavigate } from 'react-router-dom'

import { signOut } from 'core/utils/signout'

// This page can redirected to when we need to log out the user
export default function LogoutPage() {
  const navigate = useNavigate()

  useEffect(() => {
    signOut()

    navigate('/login')
  }, [navigate])

  return null
}
